const getModel = async (code: string) => {
  return await useFetch(`model/${code}`);
};

const getModels = async () => {
  return await useFetch(`models`);
};

const getTrim = async (code: string) => {
  return await useFetch(`car/${code}`);
};

const getTypes = async () => {
  return await useFetch(`types`);
};

const useFetch = async (path: string) => {
  const url = process.env.ADMIN ?? 'https://kia.live.afonso.se/api/';
  try {
    const res = await fetch(url + path, {
      headers: {
        Authorization: `Bearer ${process.env.TOKEN ?? '3|EDPCQxV8mfDffJ02N9uLzAH3S6IjLap5f3ItxRZB99d561de'}`,
      },
    });
    const data = await res.json();
    return { data, status: res.status };
  } catch (error) {
    return error;
  }
};

export { getModel, getTrim, getModels, getTypes };
